import { helpers } from "../../../../packages/helpers";

const { getProvidedDate, getDateWithOffset } = helpers.date;

const getDateData = (date: string = new Date().toISOString()) =>
  getDateWithOffset(getProvidedDate(date));

export { getDateData };
